import chicken1 from '../assets/images/products/chicken/chicken1.png'
import chicken2 from '../assets/images/products/chicken/chicken2.png'
import chicken3 from '../assets/images/products/chicken/chicken3.png'
import chicken4 from '../assets/images/products/chicken/chicken4.png'

export const chickenProductsList =
[
    {
        cat:'poultry',
        products:[
            {
                image: chicken1,
                subtitle: 'frozen chicken',
                title: 'Chicken ',
                rating: 4.2
            },
            {
                image: chicken2,
                subtitle: 'frozen chiken',
                title: 'Chicken Drumsticks',
                rating: 4.3
            },
            {
                image: chicken3,
                subtitle: 'poultry',
                title: 'Chicken Breasts',
                rating: 4.7
            },
            {
                image: chicken4,
                subtitle: 'frozen chicken',
                title: 'Chicken Wings',
                rating: 4.7
            },
        ]
    }
]